import { 
    PaymentTypeEnum,
} from "ReactApp/Types/enum";
import React from 'react';
import { PaymentNs } from "ReactApp/Types/PaymentNs";
import { showableCartInstance } from "ReactApp/Ddd/Aggregates/ShowableCart";
import { serverConfigFromHtmlInstance } from "../ServerConfigFromHtml/ServerConfigFromHtml";
import YandexPayWidgetV1 from "ReactApp/Components/YandexPayWidgetV1/YandexPayWidgetV1";
import { dateTimeFormatter } from 'ReactApp/Services/Formatters/DateTimeFormatter';
import StepperV1, { StepperV1Props, StepV1Props } from "ReactApp/Components/StepperV1/StepperV1";

/**
 * **Внимание** на данный момент именно этот компонент
 * "вручную" определяет доступные для работы методы оплаты
 */
class PaymentInfoGenerator
{
    private static _instance: PaymentInfoGenerator;

    public static get Instance() {
        return this._instance || (this._instance = new this());
    }

    generate(): PaymentNs.PaymentInfoInterface[] {
        return [
            {
                type: PaymentTypeEnum.cash,
                title: 'Наличными или картой курьеру',
                isActive: true,
                info: (
                    <>
                        Оплата вашего заказа при доставке наличными курьеру, 
                        либо банковской картой с помощью специальных 
                        переносных мобильных терминалов
                        <br/><br/>
                        Мы принимаем платежи по следующим банковским 
                        картам: Visa, Visa Electron, MasterCard, 
                        Maestro.
                    </>
                ),
                priority: 1
            },
            {
                type: PaymentTypeEnum.yandexPaySplit,
                title: 'Яндекс Сплит',
                isActive: true,
                info: () => {
                    return (
                        <YandexPayWidgetV1 {...{
                            paymentType: PaymentTypeEnum.yandexPaySplit,
                            methods: ['SPLIT'],
                            showableCart: showableCartInstance,
                        }} />
                    );
                },
                priority: 2
            },
            {
                type: PaymentTypeEnum.yandexPayFullPayment,
                title: () => {
                    return (
                        <>
                            Яндекс Пэй и получить&nbsp;
                            <span 
                                style={{
                                    display: 'block',
                                    paddingTop: '0.5rem',
                                    position: 'relative',
                                    left: '-1.7rem'
                                }}
                                dangerouslySetInnerHTML={{__html: (`
                                    <yandex-pay-badge 
                                        merchant-id="${serverConfigFromHtmlInstance.config['yandexPay']['apiKey'] || ''}" 
                                        type="cashback" 
                                        amount="${showableCartInstance.totalBaseSum}" 
                                        size="m" 
                                        theme="light" 
                                        align="center" 
                                        color="primary" 
                                    />
                                `)}}
                                >
                            </span>
                        </>
                    );
                },
                isActive: true,
                info: 'Оплата вашего заказа с помощью Яндекс Пэй с кэшбеком',
                priority: 3
            },
            {
                type: PaymentTypeEnum.online,
                title: 'Онлайн на сайте',
                isActive: true,
                info: (
                    <>
                        Оплата вашего заказа банковской картой на сайте через 
                        систему электронных платежей Яндекс.Касса
                        <br/>
                        Мы принимаем следующие способы оплаты: 
                        банковскими картами VISA, Mastercard, 
                        Maestro, Мир, JCB; Apple Pay; Google Pay; 
                        Яндекс.Деньги; оплата в кредит; 
                        Сбербанк онлайн; WebMoney; 
                        Qiwi кошелёк; Альфа-Клик.
                    </>
                ),
                priority: 4
            },
            {
                type: PaymentTypeEnum.dolyame,
                title: () => {
                    return (
                        <>
                            Долями за &nbsp;
                            <span>
                                {showableCartInstance.totalDolyamePaymentInfo?.cost} ₽
                                /
                                {showableCartInstance.totalDolyamePaymentInfo?.period}
                            </span>
                        </>
                    );
                },
                isActive: () => {
                    return (
                        showableCartInstance.totalBaseSum !== null 
                            && 
                        showableCartInstance.totalBaseSum 
                            <= 
                        showableCartInstance.dolyameMaxSum
                    );
                },
                info: () => {

                    let now: Date = new Date();
                    let stepperV1Props: StepperV1Props = {
                        isVisible: true,
                        title: 'Долями',
                        steps: [...Array(4).keys()].map(v => {
                            let step: StepV1Props = {
                                title: 
                                    v === 0 
                                        ? 'Сегодня' 
                                        : dateTimeFormatter.asDayWithFullMonth(
                                            new Date(now.setMonth(now.getMonth() + v))
                                        ),
                                subtitle: `${showableCartInstance.totalDolyamePaymentInfo?.cost} ₽`,
                            };
                            return step;
                        })
                    };


                    return (
                        <>
                            <div
                                style={{
                                    position: 'relative',
                                    width: '30%',
                                    maxWidth: '30%',
                                    minWidth: '30%',
                                }}
                                >
                                Оплачивайте 4 частями по 25% каждые 2 недели. 
                                Первый взнос сейчас.
                                <br/>
                                При оформлении нажмите на кнопку, 
                                заполните анкету и, после одобрения кредитной организацией, 
                                с вами свяжется менеджер.
                                <br/><br/>
                                <StepperV1 {...stepperV1Props} />
                                <br/>
                                Примерный график, может быть сервисный сбор
                            </div>
                        </>
                    );
                },
                priority: 5
            },
        ];
    }
}

export const paymentInfoGenerator = PaymentInfoGenerator.Instance;